import React, { useEffect, useState } from "react";

import { omit, orderBy } from "lodash";

import { useQueryDiscounts } from "@hubcapp/hooks";

import { AreaDiscountRowData, AreaDiscountsStateProviderProps } from "./types";
import { Discount, DiscountType, Region } from "@hubcapp/types";
import { mapDiscountsToTableData } from "./helpers";
import AreaDiscounts from "./AreaDiscounts";

const AreaDiscountsStateProvider: React.FC<AreaDiscountsStateProviderProps> = ({
  instructorDiscounts,
  onChange = () => {},
  areaId,
  loading = false,
  title,
  propositionId,
  productCategoryId,
}) => {
  const [discountTableData, setDiscountTableData] = useState<
    AreaDiscountRowData[]
  >();
  const [allDiscounts, setAllDiscounts] = useState<Discount[]>();
  useEffect(() => {
    if (allDiscounts) {
      setDiscountTableData(
        mapDiscountsToTableData(instructorDiscounts, allDiscounts),
      );
    }
  }, [instructorDiscounts, allDiscounts]);

  const onCompleted = (data: { region: Region }) => {
    const allDiscounts = data?.region?.discounts;
    if (allDiscounts) {
      setAllDiscounts(transformToTableData(allDiscounts as Discount[]));
    }
  };

  const transformToTableData = (discounts: Discount[]) =>
    discounts.map((discount: Discount) => ({
      ...discount,
      discountType: discount.discountType || DiscountType.NewLearner,
    }));

  const handleChange = (rows: AreaDiscountRowData[]) => {
    const updatedDiscounts = rows.map(row => omit(row, "tableData"));
    onChange(updatedDiscounts);
  };

  const { loading: discountsQueryLoading } = useQueryDiscounts(
    areaId,
    propositionId,
    productCategoryId,
    onCompleted,
  );

  return (
    <AreaDiscounts
      onChange={handleChange}
      loading={loading || discountsQueryLoading}
      data={orderBy(
        discountTableData,
        ["type", "valueType", "value"],
        ["desc", "desc", "asc"],
      )}
      title={title}
    />
  );
};

export default AreaDiscountsStateProvider;
